import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ReservaService } from '../../../../core/services/reserva.service';
import { ReservasTableComponent } from '../../../../core/components/reservas-table/reservas-table.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import {FormsModule} from '@angular/forms';
import {NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent} from 'ng-zorro-antd/form';
import {NzColDirective} from 'ng-zorro-antd/grid';
import {NzInputDirective} from 'ng-zorro-antd/input';


@Component({
  selector: 'app-reserva',
  templateUrl: './reservas-cajero.component.html',
  imports: [
    ReservasTableComponent,
    NzButtonComponent,
    NzModalModule,
    FormsModule,
    NzFormDirective,
    NzFormItemComponent,
    NzFormLabelComponent,
    NzFormControlComponent,
    NzColDirective,
    NzInputDirective
  ],
  styleUrls: ['./reservas-cajero.component.css']
})
export class ReservasCajeroComponent implements OnInit {
  reservas: any[] = [];
  isReciboModalVisible: boolean = false;
  numRecibo: string = '';
  reservaSeleccionada: any;

  constructor(
    private reservaService: ReservaService,
    private message: NzMessageService,
    private modal: NzModalService
  ) {}

  ngOnInit(): void {
    this.loadReservas();
  }

  loadReservas(): void {
    this.reservaService.getReservasSimplificadas().subscribe((reservas: any[]) => {
      this.reservas = reservas;
    });
  }


  onCheckReserva(reserva: any): void {
    this.reservaSeleccionada = reserva;
    this.numRecibo='';
    this.isReciboModalVisible = true;
  }

  submitReciboForm(): void {
    if (this.numRecibo) {
      this.reservaService.updateNumRecibo(this.reservaSeleccionada.id, this.numRecibo).subscribe(
        () => {
          const nuevoIdEstado = this.reservaSeleccionada.estado.id_estado === 1 ? 2 : 1;
          this.reservaService.updateEstadoReserva(this.reservaSeleccionada.id, nuevoIdEstado).subscribe(
            (reservaActualizada) => {
              const index = this.reservas.findIndex(r => r.id === reservaActualizada.id);
              if (index !== -1) {
                this.reservas[index].estado = reservaActualizada.estado;
              }
              this.loadReservas();
              this.message.success('Estado cambiado a Pagado y recibo actualizado');
            },
            (error) => {
              this.message.error('Error al cambiar el estado');
              console.log(error);
            }
          );
        },
        (error) => {
          this.message.error('Error al actualizar el número de recibo');
          console.log(error);
        }
      );
      this.isReciboModalVisible = false;
    } else {
      this.message.error('Por favor, ingrese un número de recibo válido');
    }
  }

  handleCancelReciboModal(): void {
    this.isReciboModalVisible = false;
  }
}


